import React from 'react';
import { Helmet } from 'react-helmet'; // TODO: html tag has hard-coded language attribute
// TODO: handle titleTemplate, pass page titile
// <Helmet defaultTitle={siteName} titleTemplate={`%s | ${siteName}`}>

var SiteMetadata = function SiteMetadata(_ref) {
  var canonical = _ref.canonical,
      siteName = _ref.siteName,
      siteUrl = _ref.siteUrl,
      title = _ref.title,
      siteIcon = _ref.siteIcon,
      siteDescription = _ref.siteDescription,
      twitterHandle = _ref.twitterHandle;
  return /*#__PURE__*/React.createElement(Helmet, {
    defaultTitle: siteName,
    titleTemplate: "%s | " + siteName
  }, /*#__PURE__*/React.createElement("html", {
    lang: "en",
    amp: true
  }), title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: siteDescription
  }), canonical && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonical
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: siteUrl
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: "website"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:locale",
    content: "en"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:site_name",
    content: siteName
  }), siteIcon && /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: "" + siteUrl + siteIcon
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image:width",
    content: "512"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image:height",
    content: "512"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image:alt",
    content: siteDescription
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:card",
    content: "summary"
  }), twitterHandle && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:site",
    content: twitterHandle
  }));
};

SiteMetadata.defaultProps = {
  canonical: null,
  siteIcon: null,
  twitterHandle: null,
  title: undefined
};
export default SiteMetadata;